import type { RepairTypeData } from "@stryker/core/types/mechanicalJobs";
import { VerifiedIcon } from "lucide-react";
import flangClampImage from "@/assets/images/flangeClamp.png";
import longRadius from "@/assets/images/longRadius.png";
import straightLine from "@/assets/images/straightLine.png";
import tee from "@/assets/images/tee.png";
import ExpandableSection from "@/components/job/ExpandableSection";
import { Typography } from "@/components/ui/typography";
import { cn } from "@/lib/utils";
import useCUMechanicalJobStore from "@/store/useCUMechanicalJobStore";

const desiredRepairTypeOptions = [
  {
    id: "straight_line",
    image: straightLine,
    text: "Straight Line",
  },
  {
    id: "tee",
    image: tee,
    text: "Tee",
  },
  {
    id: "long_radius",
    image: longRadius,
    text: "Long Radius 90",
  },
  {
    id: "flange_clamp",
    image: flangClampImage,
    text: "Flange Clamp",
  },
];

const cardName = "repairType";
export default function DesiredRepairType() {
  const { sections, toggleExpandableSection, setRepairType } = useCUMechanicalJobStore();
  const savedRepairType = sections.repairType;
  const selectedRepairType = savedRepairType.data.repairType;

  const handleSelectRepairType = (repairType: RepairTypeData["repairType"]) => {
    setRepairType({
      data: { repairType },
      status: "done",
    });
  };
  return (
    <ExpandableSection
      status={savedRepairType.status}
      setIsExpanded={() => toggleExpandableSection(cardName)}
      title="Desired Repair Type"
    >
      <div className="grid grid-cols-2 gap-4 sm:grid-cols-4">
        {desiredRepairTypeOptions.map((option) => (
          <div
            key={option.id}
            role="button"
            onClick={() => handleSelectRepairType(option.id as RepairTypeData["repairType"])}
            className={cn(
              "p-3 flex-1 flex flex-col justify-center items-center border border-solid border-gray-100-100 rounded-md hover:border-green-600 cursor-pointer",
              selectedRepairType === option.id && "border-success-200"
            )}
          >
            <img src={option.image} alt={option.text} className="" />
            <div className="flex items-center justify-center gap-2">
              {selectedRepairType === option.id && <VerifiedIcon color="green" />}
              <Typography variant="text-lg" className="text-center font-semibold">
                {option.text}
              </Typography>
            </div>
          </div>
        ))}
      </div>
    </ExpandableSection>
  );
}
